<template>
  <div>
    <el-dialog
      title="批量扣款应收选择"
      :visible.sync="dialogVisible"
      width="430px"
      :before-close="closeDialog"
    >
      <div class="create_form">
        <el-form ref="form" :rules="rules" :model="params" label-width="100px">
          <el-form-item prop="times" label="应收时间:">
            <el-date-picker
              v-model="params.times"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="createPickerOptions"
              clearable
            ></el-date-picker>
          </el-form-item>

          <el-form-item prop="tenantName" label="公司名称:">{{ userInfo.tenantName }}</el-form-item>
          <el-form-item prop="content" label="支付内容:">
            <el-select v-model="params.content" disabled>
              <el-option
                v-for="item in contentList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- </column-box> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="onOk" :loading="loading">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { receivableAccruedPreview } from '@/api/financeApi'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    paramsData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        times: [
          {
            required: true,
            message: '应收时间不能为空',
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: '支付内容不能为空',
            trigger: 'blur',
          },
        ],
      },
      loading: false,
      minDate: '',
      createPickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate.getTime()
          if (maxDate) {
            this.minDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.minDate !== '') {
            const one = 60 * 24 * 3600 * 1000
            const minTime = this.minDate - one
            const maxTime = this.minDate + one
            return time.getTime() <= minTime || time.getTime() >= maxTime
          }
        },
      },
      params: {
        times: '',
        content: 1,
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    contentList() {
      return [
        {
          value: 1,
          label: '租金',
        },
      ]
    },
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    onOk() {
      this.$refs.form.validate((value) => {
        if (value) {
          this.loading = true
          this.addReceivable()
        }
      })
    },
    async addReceivable() {
      const { paymentMode, limitAmount, weekDay, weekStartTime, weekEndTime } = this.paramsData
      const params = {
        pageNum: 1,
        pageSize: 10,
        accruedStartTime: this.params.times[0],
        accruedEndTime: this.params.times[1],
        content: this.params.content,
        accruedExeStartTime: paymentMode === 2 ? `${moment(weekStartTime).format('YYYY-MM-DD')} 00:00:00` : this.paramsData.gmtTime[0],
        accruedExeEndTime: paymentMode === 2 ? `${moment(weekEndTime).format('YYYY-MM-DD')} 23:59:59` : this.paramsData.gmtTime[1],
        accruedType: 1,
        previewId: '',
        paymentMode,
        limitAmount: paymentMode === 2 ? limitAmount : '',
        weekDay: paymentMode === 2 ? weekDay : '',
      }
      const { code, data } = await receivableAccruedPreview(params)
      if (code !== 1) {
        this.loading = false
        return
      }
      this.loading = false
      this.closeDialog()
      const total = data.totalNum ? data.totalNum : 0
      this.$message.success(`本次共选中${total}个应收`)
      this.$emit('success', { content: data, params })
    },
  },
}
</script>
<style scoped lang="scss">
.create_form {
  ::v-deep .el-input__inner {
    width: 226px;
  }
}
</style>
